import { Component, OnInit } from '@angular/core';
import { ApiService } from 'app/services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { ServiceDateType } from '../../services/service-date-type.service';


@Component({
  selector: 'app-service-date-type',
  templateUrl: './service-date-type.component.html',
  styleUrls: ['./service-date-type.component.css']
})
export class ServiceDateTypeComponent implements OnInit {


  public isLoading = false;
  public entities: ServiceDateType[];

    constructor(
      public dialog: MatDialog,
      private apiSvc: ApiService
    ) { }

    ngOnInit() {
      this.loadEntities();
    }

    private loadEntities() {

      this.isLoading = true;
      this.apiSvc.get("api/servicedateType", null).subscribe(
        (data: ServiceDateType[]) => {
          this.entities = data;
          console.log(this.entities);
          this.isLoading = false;
        },
        (err) => {
          console.log("error", err);
          this.isLoading = false;
        }
      );
  }

  public add() {
  //  const dialogRef = this.dialog.open(LanguageEditComponent, {
      //data: serviceDate,
   // });
  }

  public edit(lang) {
    console.log(lang);
    //const dialogRef = this.dialog.open(LanguageEditComponent, {
      //data: serviceDate,
   // });
  }

  public delete(lang) {
     alert("Delete obj");
     console.log(lang);
  }

  }

